interface ExpectedFields {
  fieldName?: string[] | null;
}
interface MutationErrors<T> {
  message?: string | null;
  fields: T | ExpectedFields;
}

const hasFieldErrors = <T>(errors?: MutationErrors<T> | null) => {
  return (
    !!errors?.fields &&
    Object.values(errors.fields).some(
      // array check is to ensure we are getting a field error and not the __typename field which is a string
      fieldError => Array.isArray(fieldError) && fieldError?.length > 0
    )
  );
};

const hasErrors = <T>(errors?: MutationErrors<T> | null) => {
  const hasFieldError = hasFieldErrors(errors);
  const hasTopLevelError = !!errors?.message;

  return hasFieldError || hasTopLevelError;
};

export { hasErrors, hasFieldErrors };
